//@flow
import NumberUtils from 'common/utils/NumberUtils';

import { type UnitType } from './ChartDataType';

//Includes custom units for representation also
type ValueType = {
    value: ?number | ?string,
    valueType: string
};

export const getValueAndUnit = (
    value: ?number,
    unit: UnitType,
    shortenValue?: boolean = false
): ValueType => {
    const formattedValue = NumberUtils.formatNumber(value, true, 2);
    return {
        value: shortenValue
            ? NumberUtils.shorten(formattedValue, 'k', 1000)
            : formattedValue,
        valueType: (value || 0) === 1 ? unit.label : unit.pluralLabel
    };
};
